/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * py-api
 * ML backend: FastAPI application
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import { useCallback } from 'react';

import type {
  ApiInfoResponse,
  BodyUploadModel,
  BodyUploadPlanningCsv,
  BodyUploadYardCsv,
  CountData,
  GetPlanningParams,
  GetPlanningsParams,
  GetScenariosParams,
  GetSimulationRunContainerHistoryParams,
  GetYardsParams,
  HTTPValidationError,
  HealthCheckResponse,
  ListModelsParams,
  ListYardPropertiesParams,
  ModelListResponse,
  ModelUpdateRequest,
  ModelUploadResponse,
  PlanningCreateRequest,
  PlanningDataInput,
  PlanningDataOutput,
  PlanningListResponse,
  ScenarioCreateRequest,
  ScenarioDataResponse,
  ScenarioListResponse,
  ScenarioOccupancyData,
  ScenarioResponse,
  ScenarioUpdateRequest,
  ShipVisitPlanningData,
  SimulationTraceData,
  TeuData,
  YardListResponse,
  YardMovesResponse,
  YardPropertiesCreateRequest,
  YardPropertiesListResponse,
  YardPropertiesResponse,
  YardUpload,
  YardUploadResponse,
} from './generated.schemas';

import { useCustomClient } from './instance';
import type { ErrorType, BodyType } from './instance';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Root endpoint that returns basic API information.
 * @summary Root
 */
export const useRootGetHook = () => {
  const rootGet = useCustomClient<ApiInfoResponse>();

  return useCallback(
    (signal?: AbortSignal) => {
      return rootGet({ url: `/`, method: 'GET', signal });
    },
    [rootGet]
  );
};

export const getRootGetQueryKey = () => {
  return [`/`] as const;
};

export const useRootGetQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRootGetQueryKey();

  const rootGet = useRootGetHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>
  > = ({ signal }) => rootGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RootGetQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>
>;
export type RootGetQueryError = ErrorType<unknown>;

export function useRootGet<
  TData = Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRootGet<
  TData = Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRootGet<
  TData = Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Root
 */

export function useRootGet<
  TData = Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useRootGetHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useRootGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Health check endpoint.
 * @summary Health Check
 */
export const useHealthCheckHook = () => {
  const healthCheck = useCustomClient<HealthCheckResponse>();

  return useCallback(
    (signal?: AbortSignal) => {
      return healthCheck({ url: `/health/`, method: 'GET', signal });
    },
    [healthCheck]
  );
};

export const getHealthCheckQueryKey = () => {
  return [`/health/`] as const;
};

export const useHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const healthCheck = useHealthCheckHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>
  > = ({ signal }) => healthCheck(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

export function useHealthCheck<
  TData = Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useHealthCheck<
  TData = Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useHealthCheck<
  TData = Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Health Check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useHealthCheckHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Redirects the user to Microsoft login.
 * @summary Login With Microsoft
 */
export const useLoginWithMicrosoftHook = () => {
  const loginWithMicrosoft = useCustomClient<unknown>();

  return useCallback(
    (signal?: AbortSignal) => {
      return loginWithMicrosoft({
        url: `/auth/microsoft`,
        method: 'GET',
        signal,
      });
    },
    [loginWithMicrosoft]
  );
};

export const getLoginWithMicrosoftQueryKey = () => {
  return [`/auth/microsoft`] as const;
};

export const useLoginWithMicrosoftQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLoginWithMicrosoftQueryKey();

  const loginWithMicrosoft = useLoginWithMicrosoftHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>
  > = ({ signal }) => loginWithMicrosoft(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LoginWithMicrosoftQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>
>;
export type LoginWithMicrosoftQueryError = ErrorType<unknown>;

export function useLoginWithMicrosoft<
  TData = Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLoginWithMicrosoft<
  TData = Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLoginWithMicrosoft<
  TData = Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Login With Microsoft
 */

export function useLoginWithMicrosoft<
  TData = Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useLoginWithMicrosoftHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useLoginWithMicrosoftQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Handles the callback from Microsoft with the auth code.
 * @summary Microsoft Callback
 */
export const useMicrosoftCallbackAuthMicrosoftCallbackGetHook = () => {
  const microsoftCallbackAuthMicrosoftCallbackGet = useCustomClient<unknown>();

  return useCallback(
    (signal?: AbortSignal) => {
      return microsoftCallbackAuthMicrosoftCallbackGet({
        url: `/auth/microsoft/callback`,
        method: 'GET',
        signal,
      });
    },
    [microsoftCallbackAuthMicrosoftCallbackGet]
  );
};

export const getMicrosoftCallbackAuthMicrosoftCallbackGetQueryKey = () => {
  return [`/auth/microsoft/callback`] as const;
};

export const useMicrosoftCallbackAuthMicrosoftCallbackGetQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook>
    >
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook>
        >
      >,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getMicrosoftCallbackAuthMicrosoftCallbackGetQueryKey();

  const microsoftCallbackAuthMicrosoftCallbackGet =
    useMicrosoftCallbackAuthMicrosoftCallbackGetHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook>
      >
    >
  > = ({ signal }) => microsoftCallbackAuthMicrosoftCallbackGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook>
      >
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MicrosoftCallbackAuthMicrosoftCallbackGetQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook>
    >
  >
>;
export type MicrosoftCallbackAuthMicrosoftCallbackGetQueryError =
  ErrorType<unknown>;

export function useMicrosoftCallbackAuthMicrosoftCallbackGet<
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook>
    >
  >,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook>
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              ReturnType<
                typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook
              >
            >
          >,
          TError,
          Awaited<
            ReturnType<
              ReturnType<
                typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook
              >
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useMicrosoftCallbackAuthMicrosoftCallbackGet<
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook>
    >
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook>
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              ReturnType<
                typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook
              >
            >
          >,
          TError,
          Awaited<
            ReturnType<
              ReturnType<
                typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook
              >
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useMicrosoftCallbackAuthMicrosoftCallbackGet<
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook>
    >
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook>
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Microsoft Callback
 */

export function useMicrosoftCallbackAuthMicrosoftCallbackGet<
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook>
    >
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useMicrosoftCallbackAuthMicrosoftCallbackGetHook>
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    useMicrosoftCallbackAuthMicrosoftCallbackGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Upload a Yard CSV file. Each upload is stored as an immutable record with a unique ID and upload timestamp.
 * @summary Upload Yard CSV
 */
export const useUploadYardCsvHook = () => {
  const uploadYardCsv = useCustomClient<YardUpload>();

  return useCallback(
    (bodyUploadYardCsv: BodyType<BodyUploadYardCsv>, signal?: AbortSignal) => {
      const formData = new FormData();
      formData.append(`file`, bodyUploadYardCsv.file);

      return uploadYardCsv({
        url: `/yards/`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
        signal,
      });
    },
    [uploadYardCsv]
  );
};

export const useUploadYardCsvMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUploadYardCsvHook>>>,
    TError,
    { data: BodyType<BodyUploadYardCsv> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUploadYardCsvHook>>>,
  TError,
  { data: BodyType<BodyUploadYardCsv> },
  TContext
> => {
  const mutationKey = ['uploadYardCsv'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const uploadYardCsv = useUploadYardCsvHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUploadYardCsvHook>>>,
    { data: BodyType<BodyUploadYardCsv> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadYardCsv(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadYardCsvMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUploadYardCsvHook>>>
>;
export type UploadYardCsvMutationBody = BodyType<BodyUploadYardCsv>;
export type UploadYardCsvMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Upload Yard CSV
 */
export const useUploadYardCsv = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useUploadYardCsvHook>>>,
      TError,
      { data: BodyType<BodyUploadYardCsv> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUploadYardCsvHook>>>,
  TError,
  { data: BodyType<BodyUploadYardCsv> },
  TContext
> => {
  const mutationOptions = useUploadYardCsvMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get a paginated list of yard uploads, optionally filtered by date range.
 * @summary List Yard Uploads
 */
export const useGetYardsHook = () => {
  const getYards = useCustomClient<YardListResponse>();

  return useCallback(
    (params?: GetYardsParams, signal?: AbortSignal) => {
      return getYards({ url: `/yards/`, method: 'GET', params, signal });
    },
    [getYards]
  );
};

export const getGetYardsQueryKey = (params?: GetYardsParams) => {
  return [`/yards/`, ...(params ? [params] : [])] as const;
};

export const useGetYardsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetYardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetYardsQueryKey(params);

  const getYards = useGetYardsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>
  > = ({ signal }) => getYards(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetYardsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>
>;
export type GetYardsQueryError = ErrorType<HTTPValidationError>;

export function useGetYards<
  TData = Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | GetYardsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetYards<
  TData = Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetYardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetYards<
  TData = Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetYardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Yard Uploads
 */

export function useGetYards<
  TData = Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetYardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetYardsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetYardsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve the most recent Yard CSV upload.
 * @summary Get Latest Yard CSV
 */
export const useGetLatestYardHook = () => {
  const getLatestYard = useCustomClient<YardUpload>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getLatestYard({ url: `/yards/latest`, method: 'GET', signal });
    },
    [getLatestYard]
  );
};

export const getGetLatestYardQueryKey = () => {
  return [`/yards/latest`] as const;
};

export const useGetLatestYardQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLatestYardQueryKey();

  const getLatestYard = useGetLatestYardHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>
  > = ({ signal }) => getLatestYard(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLatestYardQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>
>;
export type GetLatestYardQueryError = ErrorType<unknown>;

export function useGetLatestYard<
  TData = Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLatestYard<
  TData = Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLatestYard<
  TData = Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Latest Yard CSV
 */

export function useGetLatestYard<
  TData = Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetLatestYardHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetLatestYardQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Download the most recent Yard CSV file.
 * @summary Download Latest Yard CSV
 */
export const useDownloadLatestYardCsvHook = () => {
  const downloadLatestYardCsv = useCustomClient<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return downloadLatestYardCsv({
        url: `/yards/latest/download`,
        method: 'GET',
        signal,
      });
    },
    [downloadLatestYardCsv]
  );
};

export const getDownloadLatestYardCsvQueryKey = () => {
  return [`/yards/latest/download`] as const;
};

export const useDownloadLatestYardCsvQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadLatestYardCsvQueryKey();

  const downloadLatestYardCsv = useDownloadLatestYardCsvHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>
  > = ({ signal }) => downloadLatestYardCsv(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadLatestYardCsvQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>
>;
export type DownloadLatestYardCsvQueryError = ErrorType<unknown>;

export function useDownloadLatestYardCsv<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadLatestYardCsv<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadLatestYardCsv<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download Latest Yard CSV
 */

export function useDownloadLatestYardCsv<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadLatestYardCsvHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useDownloadLatestYardCsvQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Download a specific Yard CSV file by ID.
 * @summary Download Yard CSV
 */
export const useDownloadYardCsvHook = () => {
  const downloadYardCsv = useCustomClient<void>();

  return useCallback(
    (yardId: string, signal?: AbortSignal) => {
      return downloadYardCsv({
        url: `/yards/${yardId}/download`,
        method: 'GET',
        signal,
      });
    },
    [downloadYardCsv]
  );
};

export const getDownloadYardCsvQueryKey = (yardId: string) => {
  return [`/yards/${yardId}/download`] as const;
};

export const useDownloadYardCsvQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  yardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadYardCsvQueryKey(yardId);

  const downloadYardCsv = useDownloadYardCsvHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>
  > = ({ signal }) => downloadYardCsv(yardId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!yardId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadYardCsvQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>
>;
export type DownloadYardCsvQueryError = ErrorType<HTTPValidationError>;

export function useDownloadYardCsv<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  yardId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadYardCsv<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  yardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadYardCsv<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  yardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download Yard CSV
 */

export function useDownloadYardCsv<
  TData = Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  yardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadYardCsvHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useDownloadYardCsvQueryOptions(yardId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Delete a yard upload by ID.
 * @summary Delete Yard Upload
 */
export const useDeleteYardHook = () => {
  const deleteYard = useCustomClient<void>();

  return useCallback(
    (yardId: string) => {
      return deleteYard({ url: `/yards/${yardId}`, method: 'DELETE' });
    },
    [deleteYard]
  );
};

export const useDeleteYardMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteYardHook>>>,
    TError,
    { yardId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeleteYardHook>>>,
  TError,
  { yardId: string },
  TContext
> => {
  const mutationKey = ['deleteYard'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const deleteYard = useDeleteYardHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeleteYardHook>>>,
    { yardId: string }
  > = (props) => {
    const { yardId } = props ?? {};

    return deleteYard(yardId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteYardMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeleteYardHook>>>
>;

export type DeleteYardMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Delete Yard Upload
 */
export const useDeleteYard = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useDeleteYardHook>>>,
      TError,
      { yardId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeleteYardHook>>>,
  TError,
  { yardId: string },
  TContext
> => {
  const mutationOptions = useDeleteYardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get a yard upload's metadata by ID. Use the download endpoint for the CSV content.
 * @summary Get Yard Upload
 */
export const useGetYardHook = () => {
  const getYard = useCustomClient<YardUploadResponse>();

  return useCallback(
    (yardId: string, signal?: AbortSignal) => {
      return getYard({ url: `/yards/${yardId}`, method: 'GET', signal });
    },
    [getYard]
  );
};

export const getGetYardQueryKey = (yardId: string) => {
  return [`/yards/${yardId}`] as const;
};

export const useGetYardQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  yardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetYardQueryKey(yardId);

  const getYard = useGetYardHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>
  > = ({ signal }) => getYard(yardId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!yardId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetYardQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>
>;
export type GetYardQueryError = ErrorType<HTTPValidationError>;

export function useGetYard<
  TData = Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  yardId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetYard<
  TData = Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  yardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetYard<
  TData = Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  yardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Yard Upload
 */

export function useGetYard<
  TData = Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  yardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetYardHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetYardQueryOptions(yardId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new yard properties configuration (TEU and reefer capacity). Configurations are immutable and create-only — history is preserved so historical simulation runs remain reproducible. The newly created configuration always becomes the default.
 * @summary Create Yard Properties Configuration
 */
export const useCreateYardPropertiesHook = () => {
  const createYardProperties = useCustomClient<YardPropertiesResponse>();

  return useCallback(
    (
      yardPropertiesCreateRequest: BodyType<YardPropertiesCreateRequest>,
      signal?: AbortSignal
    ) => {
      return createYardProperties({
        url: `/yard-properties/`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: yardPropertiesCreateRequest,
        signal,
      });
    },
    [createYardProperties]
  );
};

export const useCreateYardPropertiesMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateYardPropertiesHook>>>,
    TError,
    { data: BodyType<YardPropertiesCreateRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateYardPropertiesHook>>>,
  TError,
  { data: BodyType<YardPropertiesCreateRequest> },
  TContext
> => {
  const mutationKey = ['createYardProperties'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const createYardProperties = useCreateYardPropertiesHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateYardPropertiesHook>>>,
    { data: BodyType<YardPropertiesCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createYardProperties(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateYardPropertiesMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateYardPropertiesHook>>>
>;
export type CreateYardPropertiesMutationBody =
  BodyType<YardPropertiesCreateRequest>;
export type CreateYardPropertiesMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Create Yard Properties Configuration
 */
export const useCreateYardProperties = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useCreateYardPropertiesHook>>>,
      TError,
      { data: BodyType<YardPropertiesCreateRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateYardPropertiesHook>>>,
  TError,
  { data: BodyType<YardPropertiesCreateRequest> },
  TContext
> => {
  const mutationOptions = useCreateYardPropertiesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * List all yard properties configurations with optional pagination.
 * @summary List Yard Properties Configurations
 */
export const useListYardPropertiesHook = () => {
  const listYardProperties = useCustomClient<YardPropertiesListResponse>();

  return useCallback(
    (params?: ListYardPropertiesParams, signal?: AbortSignal) => {
      return listYardProperties({
        url: `/yard-properties/`,
        method: 'GET',
        params,
        signal,
      });
    },
    [listYardProperties]
  );
};

export const getListYardPropertiesQueryKey = (
  params?: ListYardPropertiesParams
) => {
  return [`/yard-properties/`, ...(params ? [params] : [])] as const;
};

export const useListYardPropertiesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListYardPropertiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListYardPropertiesQueryKey(params);

  const listYardProperties = useListYardPropertiesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>
  > = ({ signal }) => listYardProperties(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListYardPropertiesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>
>;
export type ListYardPropertiesQueryError = ErrorType<HTTPValidationError>;

export function useListYardProperties<
  TData = Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | ListYardPropertiesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListYardProperties<
  TData = Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListYardPropertiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListYardProperties<
  TData = Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListYardPropertiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Yard Properties Configurations
 */

export function useListYardProperties<
  TData = Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListYardPropertiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListYardPropertiesHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useListYardPropertiesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a specific yard properties configuration by ID.
 * @summary Get Yard Properties Configuration
 */
export const useGetYardPropertiesHook = () => {
  const getYardProperties = useCustomClient<YardPropertiesResponse>();

  return useCallback(
    (yardPropertiesId: string, signal?: AbortSignal) => {
      return getYardProperties({
        url: `/yard-properties/${yardPropertiesId}`,
        method: 'GET',
        signal,
      });
    },
    [getYardProperties]
  );
};

export const getGetYardPropertiesQueryKey = (yardPropertiesId: string) => {
  return [`/yard-properties/${yardPropertiesId}`] as const;
};

export const useGetYardPropertiesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  yardPropertiesId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetYardPropertiesQueryKey(yardPropertiesId);

  const getYardProperties = useGetYardPropertiesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>
  > = ({ signal }) => getYardProperties(yardPropertiesId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!yardPropertiesId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetYardPropertiesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>
>;
export type GetYardPropertiesQueryError = ErrorType<HTTPValidationError>;

export function useGetYardProperties<
  TData = Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  yardPropertiesId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetYardProperties<
  TData = Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  yardPropertiesId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetYardProperties<
  TData = Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  yardPropertiesId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Yard Properties Configuration
 */

export function useGetYardProperties<
  TData = Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  yardPropertiesId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetYardPropertiesHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetYardPropertiesQueryOptions(
    yardPropertiesId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Upload a Planning CSV file. Sets is_ground_truth=true automatically.
 * @summary Upload Planning CSV
 */
export const useUploadPlanningCsvHook = () => {
  const uploadPlanningCsv = useCustomClient<PlanningDataOutput>();

  return useCallback(
    (
      bodyUploadPlanningCsv: BodyType<BodyUploadPlanningCsv>,
      signal?: AbortSignal
    ) => {
      const formData = new FormData();
      formData.append(`file`, bodyUploadPlanningCsv.file);

      return uploadPlanningCsv({
        url: `/plannings/csv`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
        signal,
      });
    },
    [uploadPlanningCsv]
  );
};

export const useUploadPlanningCsvMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUploadPlanningCsvHook>>>,
    TError,
    { data: BodyType<BodyUploadPlanningCsv> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUploadPlanningCsvHook>>>,
  TError,
  { data: BodyType<BodyUploadPlanningCsv> },
  TContext
> => {
  const mutationKey = ['uploadPlanningCsv'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const uploadPlanningCsv = useUploadPlanningCsvHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUploadPlanningCsvHook>>>,
    { data: BodyType<BodyUploadPlanningCsv> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadPlanningCsv(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadPlanningCsvMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUploadPlanningCsvHook>>>
>;
export type UploadPlanningCsvMutationBody = BodyType<BodyUploadPlanningCsv>;
export type UploadPlanningCsvMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Upload Planning CSV
 */
export const useUploadPlanningCsv = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useUploadPlanningCsvHook>>>,
      TError,
      { data: BodyType<BodyUploadPlanningCsv> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUploadPlanningCsvHook>>>,
  TError,
  { data: BodyType<BodyUploadPlanningCsv> },
  TContext
> => {
  const mutationOptions = useUploadPlanningCsvMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Upload a Planning JSON. Uses provided is_ground_truth value.
 * @summary Upload Planning JSON
 */
export const useUploadPlanningJsonHook = () => {
  const uploadPlanningJson = useCustomClient<PlanningDataOutput>();

  return useCallback(
    (
      planningCreateRequest: BodyType<PlanningCreateRequest>,
      signal?: AbortSignal
    ) => {
      return uploadPlanningJson({
        url: `/plannings/json`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: planningCreateRequest,
        signal,
      });
    },
    [uploadPlanningJson]
  );
};

export const useUploadPlanningJsonMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUploadPlanningJsonHook>>>,
    TError,
    { data: BodyType<PlanningCreateRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUploadPlanningJsonHook>>>,
  TError,
  { data: BodyType<PlanningCreateRequest> },
  TContext
> => {
  const mutationKey = ['uploadPlanningJson'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const uploadPlanningJson = useUploadPlanningJsonHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUploadPlanningJsonHook>>>,
    { data: BodyType<PlanningCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadPlanningJson(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadPlanningJsonMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUploadPlanningJsonHook>>>
>;
export type UploadPlanningJsonMutationBody = BodyType<PlanningCreateRequest>;
export type UploadPlanningJsonMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Upload Planning JSON
 */
export const useUploadPlanningJson = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useUploadPlanningJsonHook>>>,
      TError,
      { data: BodyType<PlanningCreateRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUploadPlanningJsonHook>>>,
  TError,
  { data: BodyType<PlanningCreateRequest> },
  TContext
> => {
  const mutationOptions = useUploadPlanningJsonMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get a planning by its ID.
 * @summary Get Planning by ID
 */
export const useGetPlanningHook = () => {
  const getPlanning = useCustomClient<PlanningDataOutput>();

  return useCallback(
    (planningId: string, params?: GetPlanningParams, signal?: AbortSignal) => {
      return getPlanning({
        url: `/plannings/${planningId}`,
        method: 'GET',
        params,
        signal,
      });
    },
    [getPlanning]
  );
};

export const getGetPlanningQueryKey = (
  planningId: string,
  params?: GetPlanningParams
) => {
  return [`/plannings/${planningId}`, ...(params ? [params] : [])] as const;
};

export const useGetPlanningQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  planningId: string,
  params?: GetPlanningParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlanningQueryKey(planningId, params);

  const getPlanning = useGetPlanningHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>
  > = ({ signal }) => getPlanning(planningId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!planningId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlanningQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>
>;
export type GetPlanningQueryError = ErrorType<HTTPValidationError>;

export function useGetPlanning<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  planningId: string,
  params: undefined | GetPlanningParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlanning<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  planningId: string,
  params?: GetPlanningParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlanning<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  planningId: string,
  params?: GetPlanningParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Planning by ID
 */

export function useGetPlanning<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  planningId: string,
  params?: GetPlanningParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPlanningHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetPlanningQueryOptions(planningId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a planning by ID. ship_visits replaces the complete list, including historic visits; clients must include historic visits when they need to retain them.
 * @summary Update Planning
 */
export const useUpdatePlanningHook = () => {
  const updatePlanning = useCustomClient<PlanningDataOutput>();

  return useCallback(
    (planningId: string, planningDataInput: BodyType<PlanningDataInput>) => {
      return updatePlanning({
        url: `/plannings/${planningId}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: planningDataInput,
      });
    },
    [updatePlanning]
  );
};

export const useUpdatePlanningMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdatePlanningHook>>>,
    TError,
    { planningId: string; data: BodyType<PlanningDataInput> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdatePlanningHook>>>,
  TError,
  { planningId: string; data: BodyType<PlanningDataInput> },
  TContext
> => {
  const mutationKey = ['updatePlanning'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const updatePlanning = useUpdatePlanningHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdatePlanningHook>>>,
    { planningId: string; data: BodyType<PlanningDataInput> }
  > = (props) => {
    const { planningId, data } = props ?? {};

    return updatePlanning(planningId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlanningMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdatePlanningHook>>>
>;
export type UpdatePlanningMutationBody = BodyType<PlanningDataInput>;
export type UpdatePlanningMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Update Planning
 */
export const useUpdatePlanning = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useUpdatePlanningHook>>>,
      TError,
      { planningId: string; data: BodyType<PlanningDataInput> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdatePlanningHook>>>,
  TError,
  { planningId: string; data: BodyType<PlanningDataInput> },
  TContext
> => {
  const mutationOptions = useUpdatePlanningMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Delete a planning by ID.
 * @summary Delete Planning
 */
export const useDeletePlanningHook = () => {
  const deletePlanning = useCustomClient<void>();

  return useCallback(
    (planningId: string) => {
      return deletePlanning({
        url: `/plannings/${planningId}`,
        method: 'DELETE',
      });
    },
    [deletePlanning]
  );
};

export const useDeletePlanningMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeletePlanningHook>>>,
    TError,
    { planningId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeletePlanningHook>>>,
  TError,
  { planningId: string },
  TContext
> => {
  const mutationKey = ['deletePlanning'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const deletePlanning = useDeletePlanningHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeletePlanningHook>>>,
    { planningId: string }
  > = (props) => {
    const { planningId } = props ?? {};

    return deletePlanning(planningId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePlanningMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeletePlanningHook>>>
>;

export type DeletePlanningMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Delete Planning
 */
export const useDeletePlanning = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useDeletePlanningHook>>>,
      TError,
      { planningId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeletePlanningHook>>>,
  TError,
  { planningId: string },
  TContext
> => {
  const mutationOptions = useDeletePlanningMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get a paginated list of plannings, optionally filtered by date range and is_ground_truth.
 * @summary List Plannings
 */
export const useGetPlanningsHook = () => {
  const getPlannings = useCustomClient<PlanningListResponse>();

  return useCallback(
    (params?: GetPlanningsParams, signal?: AbortSignal) => {
      return getPlannings({
        url: `/plannings/`,
        method: 'GET',
        params,
        signal,
      });
    },
    [getPlannings]
  );
};

export const getGetPlanningsQueryKey = (params?: GetPlanningsParams) => {
  return [`/plannings/`, ...(params ? [params] : [])] as const;
};

export const useGetPlanningsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetPlanningsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlanningsQueryKey(params);

  const getPlannings = useGetPlanningsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>
  > = ({ signal }) => getPlannings(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlanningsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>
>;
export type GetPlanningsQueryError = ErrorType<HTTPValidationError>;

export function useGetPlannings<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | GetPlanningsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlannings<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetPlanningsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlannings<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetPlanningsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Plannings
 */

export function useGetPlannings<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetPlanningsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPlanningsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetPlanningsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Upload a zip archive containing model_config.json (required — its `type` field determines the rest of the archive's expected contents) plus, for XGBoostLSS models, the 6 trained model files (n_import_reefer_True.ubj, n_import_reefer_False.ubj, n_transshipment_reefer_True.ubj, n_transshipment_reefer_False.ubj, n_export_reefer_True.ubj, n_export_reefer_False.ubj). GlobalRidge and LinearLSS models carry their fitted weights directly inside model_config.json. Each model is validated before storing.
 * @summary Upload ML Model
 */
export const useUploadModelHook = () => {
  const uploadModel = useCustomClient<ModelUploadResponse>();

  return useCallback(
    (bodyUploadModel: BodyType<BodyUploadModel>, signal?: AbortSignal) => {
      const formData = new FormData();
      formData.append(`model_name`, bodyUploadModel.model_name);
      formData.append(`file`, bodyUploadModel.file);
      if (bodyUploadModel.is_default !== undefined) {
        formData.append(`is_default`, bodyUploadModel.is_default.toString());
      }

      return uploadModel({
        url: `/models/`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
        signal,
      });
    },
    [uploadModel]
  );
};

export const useUploadModelMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUploadModelHook>>>,
    TError,
    { data: BodyType<BodyUploadModel> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUploadModelHook>>>,
  TError,
  { data: BodyType<BodyUploadModel> },
  TContext
> => {
  const mutationKey = ['uploadModel'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const uploadModel = useUploadModelHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUploadModelHook>>>,
    { data: BodyType<BodyUploadModel> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadModel(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadModelMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUploadModelHook>>>
>;
export type UploadModelMutationBody = BodyType<BodyUploadModel>;
export type UploadModelMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Upload ML Model
 */
export const useUploadModel = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useUploadModelHook>>>,
      TError,
      { data: BodyType<BodyUploadModel> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUploadModelHook>>>,
  TError,
  { data: BodyType<BodyUploadModel> },
  TContext
> => {
  const mutationOptions = useUploadModelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * List uploaded ML models, newest first, with optional pagination.
 * @summary List ML Models
 */
export const useListModelsHook = () => {
  const listModels = useCustomClient<ModelListResponse>();

  return useCallback(
    (params?: ListModelsParams, signal?: AbortSignal) => {
      return listModels({ url: `/models/`, method: 'GET', params, signal });
    },
    [listModels]
  );
};

export const getListModelsQueryKey = (params?: ListModelsParams) => {
  return [`/models/`, ...(params ? [params] : [])] as const;
};

export const useListModelsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListModelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListModelsQueryKey(params);

  const listModels = useListModelsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>
  > = ({ signal }) => listModels(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListModelsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>
>;
export type ListModelsQueryError = ErrorType<HTTPValidationError>;

export function useListModels<
  TData = Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | ListModelsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListModels<
  TData = Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListModelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListModels<
  TData = Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListModelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List ML Models
 */

export function useListModels<
  TData = Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListModelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListModelsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useListModelsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get metadata for a specific ML model by ID.
 * @summary Get ML Model
 */
export const useGetModelHook = () => {
  const getModel = useCustomClient<ModelUploadResponse>();

  return useCallback(
    (modelId: string, signal?: AbortSignal) => {
      return getModel({ url: `/models/${modelId}`, method: 'GET', signal });
    },
    [getModel]
  );
};

export const getGetModelQueryKey = (modelId: string) => {
  return [`/models/${modelId}`] as const;
};

export const useGetModelQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  modelId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModelQueryKey(modelId);

  const getModel = useGetModelHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>
  > = ({ signal }) => getModel(modelId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!modelId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetModelQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>
>;
export type GetModelQueryError = ErrorType<HTTPValidationError>;

export function useGetModel<
  TData = Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  modelId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetModel<
  TData = Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  modelId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetModel<
  TData = Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  modelId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get ML Model
 */

export function useGetModel<
  TData = Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  modelId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetModelHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetModelQueryOptions(modelId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update metadata for an existing ML model, e.g. rename it or mark it as the default.
 * @summary Update ML Model
 */
export const useUpdateModelHook = () => {
  const updateModel = useCustomClient<ModelUploadResponse>();

  return useCallback(
    (modelId: string, modelUpdateRequest: BodyType<ModelUpdateRequest>) => {
      return updateModel({
        url: `/models/${modelId}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: modelUpdateRequest,
      });
    },
    [updateModel]
  );
};

export const useUpdateModelMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateModelHook>>>,
    TError,
    { modelId: string; data: BodyType<ModelUpdateRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateModelHook>>>,
  TError,
  { modelId: string; data: BodyType<ModelUpdateRequest> },
  TContext
> => {
  const mutationKey = ['updateModel'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const updateModel = useUpdateModelHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateModelHook>>>,
    { modelId: string; data: BodyType<ModelUpdateRequest> }
  > = (props) => {
    const { modelId, data } = props ?? {};

    return updateModel(modelId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateModelMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateModelHook>>>
>;
export type UpdateModelMutationBody = BodyType<ModelUpdateRequest>;
export type UpdateModelMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Update ML Model
 */
export const useUpdateModel = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useUpdateModelHook>>>,
      TError,
      { modelId: string; data: BodyType<ModelUpdateRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateModelHook>>>,
  TError,
  { modelId: string; data: BodyType<ModelUpdateRequest> },
  TContext
> => {
  const mutationOptions = useUpdateModelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Delete an ML model by ID.
 * @summary Delete ML Model
 */
export const useDeleteModelHook = () => {
  const deleteModel = useCustomClient<void>();

  return useCallback(
    (modelId: string) => {
      return deleteModel({ url: `/models/${modelId}`, method: 'DELETE' });
    },
    [deleteModel]
  );
};

export const useDeleteModelMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteModelHook>>>,
    TError,
    { modelId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeleteModelHook>>>,
  TError,
  { modelId: string },
  TContext
> => {
  const mutationKey = ['deleteModel'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const deleteModel = useDeleteModelHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeleteModelHook>>>,
    { modelId: string }
  > = (props) => {
    const { modelId } = props ?? {};

    return deleteModel(modelId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteModelMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeleteModelHook>>>
>;

export type DeleteModelMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Delete ML Model
 */
export const useDeleteModel = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useDeleteModelHook>>>,
      TError,
      { modelId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeleteModelHook>>>,
  TError,
  { modelId: string },
  TContext
> => {
  const mutationOptions = useDeleteModelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Launch a multi-scenario simulation using a Planning ID and Yard ID.
 * @summary Launch a Simulation
 */
export const useCreateScenarioHook = () => {
  const createScenario = useCustomClient<ScenarioResponse>();

  return useCallback(
    (
      scenarioCreateRequest: BodyType<ScenarioCreateRequest>,
      signal?: AbortSignal
    ) => {
      return createScenario({
        url: `/scenarios/`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: scenarioCreateRequest,
        signal,
      });
    },
    [createScenario]
  );
};

export const useCreateScenarioMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateScenarioHook>>>,
    TError,
    { data: BodyType<ScenarioCreateRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateScenarioHook>>>,
  TError,
  { data: BodyType<ScenarioCreateRequest> },
  TContext
> => {
  const mutationKey = ['createScenario'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const createScenario = useCreateScenarioHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateScenarioHook>>>,
    { data: BodyType<ScenarioCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createScenario(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateScenarioMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateScenarioHook>>>
>;
export type CreateScenarioMutationBody = BodyType<ScenarioCreateRequest>;
export type CreateScenarioMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Launch a Simulation
 */
export const useCreateScenario = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useCreateScenarioHook>>>,
      TError,
      { data: BodyType<ScenarioCreateRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateScenarioHook>>>,
  TError,
  { data: BodyType<ScenarioCreateRequest> },
  TContext
> => {
  const mutationOptions = useCreateScenarioMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * List scenarios with optional filtering and pagination.
 * @summary List Scenarios
 */
export const useGetScenariosHook = () => {
  const getScenarios = useCustomClient<ScenarioListResponse>();

  return useCallback(
    (params?: GetScenariosParams, signal?: AbortSignal) => {
      return getScenarios({
        url: `/scenarios/`,
        method: 'GET',
        params,
        signal,
      });
    },
    [getScenarios]
  );
};

export const getGetScenariosQueryKey = (params?: GetScenariosParams) => {
  return [`/scenarios/`, ...(params ? [params] : [])] as const;
};

export const useGetScenariosQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetScenariosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetScenariosQueryKey(params);

  const getScenarios = useGetScenariosHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>
  > = ({ signal }) => getScenarios(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetScenariosQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>
>;
export type GetScenariosQueryError = ErrorType<HTTPValidationError>;

export function useGetScenarios<
  TData = Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | GetScenariosParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetScenarios<
  TData = Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetScenariosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetScenarios<
  TData = Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetScenariosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Scenarios
 */

export function useGetScenarios<
  TData = Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetScenariosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetScenariosHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetScenariosQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get basic metadata and progress for a scenario.
 * @summary Get Scenario Metadata
 */
export const useGetScenarioHook = () => {
  const getScenario = useCustomClient<ScenarioResponse>();

  return useCallback(
    (scenarioId: string, signal?: AbortSignal) => {
      return getScenario({
        url: `/scenarios/${scenarioId}`,
        method: 'GET',
        signal,
      });
    },
    [getScenario]
  );
};

export const getGetScenarioQueryKey = (scenarioId: string) => {
  return [`/scenarios/${scenarioId}`] as const;
};

export const useGetScenarioQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  scenarioId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetScenarioQueryKey(scenarioId);

  const getScenario = useGetScenarioHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>
  > = ({ signal }) => getScenario(scenarioId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!scenarioId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetScenarioQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>
>;
export type GetScenarioQueryError = ErrorType<HTTPValidationError>;

export function useGetScenario<
  TData = Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  scenarioId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetScenario<
  TData = Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  scenarioId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetScenario<
  TData = Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  scenarioId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Scenario Metadata
 */

export function useGetScenario<
  TData = Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  scenarioId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetScenarioHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetScenarioQueryOptions(scenarioId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Rename a scenario. Allowed whatever the scenario's progress.
 * @summary Update Scenario
 */
export const useUpdateScenarioHook = () => {
  const updateScenario = useCustomClient<ScenarioResponse>();

  return useCallback(
    (
      scenarioId: string,
      scenarioUpdateRequest: BodyType<ScenarioUpdateRequest>
    ) => {
      return updateScenario({
        url: `/scenarios/${scenarioId}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: scenarioUpdateRequest,
      });
    },
    [updateScenario]
  );
};

export const useUpdateScenarioMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateScenarioHook>>>,
    TError,
    { scenarioId: string; data: BodyType<ScenarioUpdateRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateScenarioHook>>>,
  TError,
  { scenarioId: string; data: BodyType<ScenarioUpdateRequest> },
  TContext
> => {
  const mutationKey = ['updateScenario'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const updateScenario = useUpdateScenarioHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateScenarioHook>>>,
    { scenarioId: string; data: BodyType<ScenarioUpdateRequest> }
  > = (props) => {
    const { scenarioId, data } = props ?? {};

    return updateScenario(scenarioId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateScenarioMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateScenarioHook>>>
>;
export type UpdateScenarioMutationBody = BodyType<ScenarioUpdateRequest>;
export type UpdateScenarioMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Update Scenario
 */
export const useUpdateScenario = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useUpdateScenarioHook>>>,
      TError,
      { scenarioId: string; data: BodyType<ScenarioUpdateRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateScenarioHook>>>,
  TError,
  { scenarioId: string; data: BodyType<ScenarioUpdateRequest> },
  TContext
> => {
  const mutationOptions = useUpdateScenarioMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Delete a scenario by ID.
 * @summary Delete Scenario
 */
export const useDeleteScenarioHook = () => {
  const deleteScenario = useCustomClient<void>();

  return useCallback(
    (scenarioId: string) => {
      return deleteScenario({
        url: `/scenarios/${scenarioId}`,
        method: 'DELETE',
      });
    },
    [deleteScenario]
  );
};

export const useDeleteScenarioMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteScenarioHook>>>,
    TError,
    { scenarioId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeleteScenarioHook>>>,
  TError,
  { scenarioId: string },
  TContext
> => {
  const mutationKey = ['deleteScenario'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const deleteScenario = useDeleteScenarioHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeleteScenarioHook>>>,
    { scenarioId: string }
  > = (props) => {
    const { scenarioId } = props ?? {};

    return deleteScenario(scenarioId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteScenarioMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeleteScenarioHook>>>
>;

export type DeleteScenarioMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Delete Scenario
 */
export const useDeleteScenario = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useDeleteScenarioHook>>>,
      TError,
      { scenarioId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeleteScenarioHook>>>,
  TError,
  { scenarioId: string },
  TContext
> => {
  const mutationOptions = useDeleteScenarioMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get raw per-scenario results for a simulation.
 * @summary Get Scenario Raw Data
 */
export const useGetScenarioDataHook = () => {
  const getScenarioData = useCustomClient<ScenarioDataResponse>();

  return useCallback(
    (scenarioId: string, signal?: AbortSignal) => {
      return getScenarioData({
        url: `/scenarios/${scenarioId}/data`,
        method: 'GET',
        signal,
      });
    },
    [getScenarioData]
  );
};

export const getGetScenarioDataQueryKey = (scenarioId: string) => {
  return [`/scenarios/${scenarioId}/data`] as const;
};

export const useGetScenarioDataQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  scenarioId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetScenarioDataQueryKey(scenarioId);

  const getScenarioData = useGetScenarioDataHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>
  > = ({ signal }) => getScenarioData(scenarioId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!scenarioId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetScenarioDataQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>
>;
export type GetScenarioDataQueryError = ErrorType<HTTPValidationError>;

export function useGetScenarioData<
  TData = Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  scenarioId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetScenarioData<
  TData = Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  scenarioId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetScenarioData<
  TData = Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  scenarioId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Scenario Raw Data
 */

export function useGetScenarioData<
  TData = Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  scenarioId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetScenarioDataHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetScenarioDataQueryOptions(scenarioId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get occupancy data for a scenario.
 * @summary Get Occupancy Data
 */
export const useGetOccupancyDataHook = () => {
  const getOccupancyData = useCustomClient<ScenarioOccupancyData>();

  return useCallback(
    (scenarioId: string, signal?: AbortSignal) => {
      return getOccupancyData({
        url: `/scenarios/${scenarioId}/occupancy`,
        method: 'GET',
        signal,
      });
    },
    [getOccupancyData]
  );
};

export const getGetOccupancyDataQueryKey = (scenarioId: string) => {
  return [`/scenarios/${scenarioId}/occupancy`] as const;
};

export const useGetOccupancyDataQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  scenarioId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOccupancyDataQueryKey(scenarioId);

  const getOccupancyData = useGetOccupancyDataHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>
  > = ({ signal }) => getOccupancyData(scenarioId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!scenarioId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOccupancyDataQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>
>;
export type GetOccupancyDataQueryError = ErrorType<HTTPValidationError>;

export function useGetOccupancyData<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  scenarioId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOccupancyData<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  scenarioId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOccupancyData<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  scenarioId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Occupancy Data
 */

export function useGetOccupancyData<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  scenarioId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOccupancyDataHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetOccupancyDataQueryOptions(scenarioId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the relevant ship visits used for a simulation run.
 * @summary Get Ship Visits
 */
export const useGetSimulationRunShipVisitsHook = () => {
  const getSimulationRunShipVisits = useCustomClient<ShipVisitPlanningData>();

  return useCallback(
    (simulationRunId: string, signal?: AbortSignal) => {
      return getSimulationRunShipVisits({
        url: `/simulation-runs/${simulationRunId}/ship_visits`,
        method: 'GET',
        signal,
      });
    },
    [getSimulationRunShipVisits]
  );
};

export const getGetSimulationRunShipVisitsQueryKey = (
  simulationRunId: string
) => {
  return [`/simulation-runs/${simulationRunId}/ship_visits`] as const;
};

export const useGetSimulationRunShipVisitsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSimulationRunShipVisitsQueryKey(simulationRunId);

  const getSimulationRunShipVisits = useGetSimulationRunShipVisitsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>>
  > = ({ signal }) => getSimulationRunShipVisits(simulationRunId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!simulationRunId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSimulationRunShipVisitsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>>
>;
export type GetSimulationRunShipVisitsQueryError =
  ErrorType<HTTPValidationError>;

export function useGetSimulationRunShipVisits<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>
          >,
          TError,
          Awaited<
            ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationRunShipVisits<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>
          >,
          TError,
          Awaited<
            ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationRunShipVisits<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Ship Visits
 */

export function useGetSimulationRunShipVisits<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunShipVisitsHook>>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetSimulationRunShipVisitsQueryOptions(
    simulationRunId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the per-ship-visit enrichment provenance (extrapolated vs. predicted, features, model predictions) for a simulation run.
 * @summary Get Simulation Trace
 */
export const useGetSimulationRunTraceHook = () => {
  const getSimulationRunTrace = useCustomClient<SimulationTraceData>();

  return useCallback(
    (simulationRunId: string, signal?: AbortSignal) => {
      return getSimulationRunTrace({
        url: `/simulation-runs/${simulationRunId}/trace`,
        method: 'GET',
        signal,
      });
    },
    [getSimulationRunTrace]
  );
};

export const getGetSimulationRunTraceQueryKey = (simulationRunId: string) => {
  return [`/simulation-runs/${simulationRunId}/trace`] as const;
};

export const useGetSimulationRunTraceQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSimulationRunTraceQueryKey(simulationRunId);

  const getSimulationRunTrace = useGetSimulationRunTraceHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>
  > = ({ signal }) => getSimulationRunTrace(simulationRunId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!simulationRunId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSimulationRunTraceQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>
>;
export type GetSimulationRunTraceQueryError = ErrorType<HTTPValidationError>;

export function useGetSimulationRunTrace<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationRunTrace<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationRunTrace<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Simulation Trace
 */

export function useGetSimulationRunTrace<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTraceHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetSimulationRunTraceQueryOptions(
    simulationRunId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get count data for a simulation run.
 * @summary Get Count Data
 */
export const useGetSimulationRunCountDataHook = () => {
  const getSimulationRunCountData = useCustomClient<CountData>();

  return useCallback(
    (simulationRunId: string, signal?: AbortSignal) => {
      return getSimulationRunCountData({
        url: `/simulation-runs/${simulationRunId}/count`,
        method: 'GET',
        signal,
      });
    },
    [getSimulationRunCountData]
  );
};

export const getGetSimulationRunCountDataQueryKey = (
  simulationRunId: string
) => {
  return [`/simulation-runs/${simulationRunId}/count`] as const;
};

export const useGetSimulationRunCountDataQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSimulationRunCountDataQueryKey(simulationRunId);

  const getSimulationRunCountData = useGetSimulationRunCountDataHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>>
  > = ({ signal }) => getSimulationRunCountData(simulationRunId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!simulationRunId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSimulationRunCountDataQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>>
>;
export type GetSimulationRunCountDataQueryError =
  ErrorType<HTTPValidationError>;

export function useGetSimulationRunCountData<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>
          >,
          TError,
          Awaited<
            ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationRunCountData<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>
          >,
          TError,
          Awaited<
            ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationRunCountData<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Count Data
 */

export function useGetSimulationRunCountData<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunCountDataHook>>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetSimulationRunCountDataQueryOptions(
    simulationRunId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Download the full container history for a simulation run as CSV or Excel.
 * @summary Get Container History
 */
export const useGetSimulationRunContainerHistoryHook = () => {
  const getSimulationRunContainerHistory = useCustomClient<unknown>();

  return useCallback(
    (
      simulationRunId: string,
      params: GetSimulationRunContainerHistoryParams,
      signal?: AbortSignal
    ) => {
      return getSimulationRunContainerHistory({
        url: `/simulation-runs/${simulationRunId}/container-history`,
        method: 'GET',
        params,
        signal,
      });
    },
    [getSimulationRunContainerHistory]
  );
};

export const getGetSimulationRunContainerHistoryQueryKey = (
  simulationRunId: string,
  params: GetSimulationRunContainerHistoryParams
) => {
  return [
    `/simulation-runs/${simulationRunId}/container-history`,
    ...(params ? [params] : []),
  ] as const;
};

export const useGetSimulationRunContainerHistoryQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunContainerHistoryHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  params: GetSimulationRunContainerHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunContainerHistoryHook>>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSimulationRunContainerHistoryQueryKey(simulationRunId, params);

  const getSimulationRunContainerHistory =
    useGetSimulationRunContainerHistoryHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetSimulationRunContainerHistoryHook>>
    >
  > = ({ signal }) =>
    getSimulationRunContainerHistory(simulationRunId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!simulationRunId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetSimulationRunContainerHistoryHook>>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSimulationRunContainerHistoryQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunContainerHistoryHook>>
  >
>;
export type GetSimulationRunContainerHistoryQueryError =
  ErrorType<HTTPValidationError>;

export function useGetSimulationRunContainerHistory<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunContainerHistoryHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  params: GetSimulationRunContainerHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunContainerHistoryHook>>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              ReturnType<typeof useGetSimulationRunContainerHistoryHook>
            >
          >,
          TError,
          Awaited<
            ReturnType<
              ReturnType<typeof useGetSimulationRunContainerHistoryHook>
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationRunContainerHistory<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunContainerHistoryHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  params: GetSimulationRunContainerHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunContainerHistoryHook>>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              ReturnType<typeof useGetSimulationRunContainerHistoryHook>
            >
          >,
          TError,
          Awaited<
            ReturnType<
              ReturnType<typeof useGetSimulationRunContainerHistoryHook>
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationRunContainerHistory<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunContainerHistoryHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  params: GetSimulationRunContainerHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunContainerHistoryHook>>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Container History
 */

export function useGetSimulationRunContainerHistory<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunContainerHistoryHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  params: GetSimulationRunContainerHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunContainerHistoryHook>>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetSimulationRunContainerHistoryQueryOptions(
    simulationRunId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get container moves into and out of the yard per shift, ship visit and transport mode for a simulation run.
 * @summary Get Yard Moves
 */
export const useGetSimulationRunYardMovesHook = () => {
  const getSimulationRunYardMoves = useCustomClient<YardMovesResponse>();

  return useCallback(
    (simulationRunId: string, signal?: AbortSignal) => {
      return getSimulationRunYardMoves({
        url: `/simulation-runs/${simulationRunId}/yard-moves`,
        method: 'GET',
        signal,
      });
    },
    [getSimulationRunYardMoves]
  );
};

export const getGetSimulationRunYardMovesQueryKey = (
  simulationRunId: string
) => {
  return [`/simulation-runs/${simulationRunId}/yard-moves`] as const;
};

export const useGetSimulationRunYardMovesQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSimulationRunYardMovesQueryKey(simulationRunId);

  const getSimulationRunYardMoves = useGetSimulationRunYardMovesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>>
  > = ({ signal }) => getSimulationRunYardMoves(simulationRunId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!simulationRunId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSimulationRunYardMovesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>>
>;
export type GetSimulationRunYardMovesQueryError =
  ErrorType<HTTPValidationError>;

export function useGetSimulationRunYardMoves<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>
          >,
          TError,
          Awaited<
            ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationRunYardMoves<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>
          >,
          TError,
          Awaited<
            ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationRunYardMoves<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Yard Moves
 */

export function useGetSimulationRunYardMoves<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSimulationRunYardMovesHook>>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetSimulationRunYardMovesQueryOptions(
    simulationRunId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get TEU data for a simulation run.
 * @summary Get TEU Data
 */
export const useGetSimulationRunTeuDataHook = () => {
  const getSimulationRunTeuData = useCustomClient<TeuData>();

  return useCallback(
    (simulationRunId: string, signal?: AbortSignal) => {
      return getSimulationRunTeuData({
        url: `/simulation-runs/${simulationRunId}/teu`,
        method: 'GET',
        signal,
      });
    },
    [getSimulationRunTeuData]
  );
};

export const getGetSimulationRunTeuDataQueryKey = (simulationRunId: string) => {
  return [`/simulation-runs/${simulationRunId}/teu`] as const;
};

export const useGetSimulationRunTeuDataQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSimulationRunTeuDataQueryKey(simulationRunId);

  const getSimulationRunTeuData = useGetSimulationRunTeuDataHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>>
  > = ({ signal }) => getSimulationRunTeuData(simulationRunId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!simulationRunId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSimulationRunTeuDataQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>>
>;
export type GetSimulationRunTeuDataQueryError = ErrorType<HTTPValidationError>;

export function useGetSimulationRunTeuData<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>
          >,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationRunTeuData<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>
          >,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationRunTeuData<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get TEU Data
 */

export function useGetSimulationRunTeuData<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSimulationRunTeuDataHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetSimulationRunTeuDataQueryOptions(
    simulationRunId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return the list of vessel names that were not found in the TEU lookup dataset when this simulation run was created. Use this data to expand the TEU dataset (unique_vessels.txt) with new entries.
 * @summary Get Missing TEU Vessels
 */
export const useGetSimulationRunMissingTeuVesselsHook = () => {
  const getSimulationRunMissingTeuVessels = useCustomClient<string[]>();

  return useCallback(
    (simulationRunId: string, signal?: AbortSignal) => {
      return getSimulationRunMissingTeuVessels({
        url: `/simulation-runs/${simulationRunId}/missing-teu-vessels`,
        method: 'GET',
        signal,
      });
    },
    [getSimulationRunMissingTeuVessels]
  );
};

export const getGetSimulationRunMissingTeuVesselsQueryKey = (
  simulationRunId: string
) => {
  return [`/simulation-runs/${simulationRunId}/missing-teu-vessels`] as const;
};

export const useGetSimulationRunMissingTeuVesselsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>
          >
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSimulationRunMissingTeuVesselsQueryKey(simulationRunId);

  const getSimulationRunMissingTeuVessels =
    useGetSimulationRunMissingTeuVesselsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>>
    >
  > = ({ signal }) =>
    getSimulationRunMissingTeuVessels(simulationRunId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!simulationRunId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSimulationRunMissingTeuVesselsQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>>
  >
>;
export type GetSimulationRunMissingTeuVesselsQueryError =
  ErrorType<HTTPValidationError>;

export function useGetSimulationRunMissingTeuVessels<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>
            >
          >,
          TError,
          Awaited<
            ReturnType<
              ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationRunMissingTeuVessels<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>
            >
          >,
          TError,
          Awaited<
            ReturnType<
              ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationRunMissingTeuVessels<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Missing TEU Vessels
 */

export function useGetSimulationRunMissingTeuVessels<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  simulationRunId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetSimulationRunMissingTeuVesselsHook>
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetSimulationRunMissingTeuVesselsQueryOptions(
    simulationRunId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
